import { FC } from "react";
import styled from "styled-components";

interface CartBonuses {
  total: number;
  connected: boolean;
}

const CartBonuses: FC<CartBonuses> = ({ total, connected }) => {
  return (
    <>
      <Title>Баланс бонусного счета</Title>
      {connected ? null : (
        <Warning>
          <span>Бонусная карта не привязана</span>
        </Warning>
      )}
      <Row>
        <Icon
          style={{
            backgroundImage: `url('/static/icons/bonus-${
              connected ? "green" : "red"
            }.svg')`,
          }}
        />
        <Text>{total} ₽</Text>
      </Row>

      {connected ? null : (
        <Item href="/bonus-program" target="_blank">
          Как привязать бонусную карту
        </Item>
      )}

      <Item href="/bonus-program#spend" target="_blank">
        Как списывать накопленные бонусы
      </Item>
    </>
  );
};

const Item = styled.a`
  display: block;
  margin: 0 -20px;
  padding: 14px 20px;
  font-size: 12px;
  line-height: 14px;
  color: #78b833;
  border-top: 1px solid rgba(151, 151, 151, 0.15);

  &:last-child {
    margin-bottom: -20px;
  }
`;

const Title = styled.p`
  font-size: 14px;
  line-height: 1.2;
  margin: 0;
`;

const Warning = styled.p`
  display: flex;
  align-items: center;
  margin: 10px 0 18px;
  font-size: 12px;
  line-height: 120%;
  color: #ff0000;

  &:before {
    flex-shrink: 0;
    display: block;
    margin-right: 4px;
    width: 15px;
    height: 15px;
    background: url("/static/icons/warning.svg") no-repeat center;
    background-size: contain;
    content: "";
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  margin: 18px 0 20px;
`;

const Icon = styled.span`
  display: inline-block;
  width: 31px;
  height: 22px;
  margin-right: 9px;
  background-size: contain;
  background-repeat: no-repeat;
`;

const Text = styled.p`
  font-size: 22px;
  line-height: 26px;
  margin: 0;
`;

export default CartBonuses;
